export default class EmbedVideo {
    constructor(element = null) {
        if (!element) return;
        this.videoWrapper = element;

        var tag = document.createElement('script');
        tag.id = 'iframe-helper';
        tag.src = "https://www.youtube.com/iframe_api";
        
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        this.player = null;

        this.done = false;
        this.controls = this.videoWrapper.nextElementSibling.classList.contains('video-controls') ? this.videoWrapper.nextElementSibling : null;
        this.muteBtn = this.controls ? this.controls.querySelector('.mute-control') : null;
        this.pauseBtn = this.controls ? this.controls.querySelector('.pause-control') : null;

        this.events();
    }

    onYouTubeIframeAPIReady() {
        this.player = new YT.Player('video-embed-iframe', {
            events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            }
        });
    }

    onPlayerReady(event) {
        // console.log('onPlayerReady');
        event.target.playVideo();
    }

    onPlayerStateChange(event) {
        // console.log('onPlayerStateChange');
        // if (event.data == YT.PlayerState.PLAYING && !done) {
        // 	setTimeout(stopVideo, 6000);
        // 	this.done = true;
        // }
    }

    onPauseBtnClick(ev) {
        if (this.player.getPlayerState() === 1) {
            this.pauseVideo.bind(this)();
        } else {
            this.unpauseVideo.bind(this)();
        }
    }

    onMuteBtnClick(ev) {
        this.player.isMuted() ? this.player.unMute() : this.player.mute();
        ev.currentTarget.querySelector('.icon').classList.toggle('stop');
    }

    pauseVideo() {
        if (this.player.getPlayerState() === 1 ) {
            this.player.pauseVideo()
            this.pauseBtn.querySelector('.icon').classList.add('stop');
        }
    }

    unpauseVideo() {
        if (this.player.getPlayerState() === 2) {
            this.player.playVideo();
            this.pauseBtn.querySelector('.icon').classList.remove('stop');
        }
    }

    onWindowLoad(ev) {
        let hidden, visibilityState, visibilityChange;

        if (typeof document.hidden !== "undefined") {
            hidden = "hidden", visibilityChange = "visibilitychange", visibilityState = "visibilityState";
        }
        else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden", visibilityChange = "mozvisibilitychange", visibilityState = "mozVisibilityState";
        }
        else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden", visibilityChange = "msvisibilitychange", visibilityState = "msVisibilityState";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden", visibilityChange = "webkitvisibilitychange", visibilityState = "webkitVisibilityState";
        }

        document.addEventListener(visibilityChange, () => {
            // console.log("hidden: " + document[hidden]);
            // console.log(document[visibilityState]);

            switch (document[visibilityState]) {
            case "visible":
                if (this.videoWrapper.classList.contains('is-in-view')) {
                    this.unpauseVideo.bind(this)();
                }
                break;
            case "hidden":
                this.pauseVideo.bind(this)();
                break;
            }
        });
    }

    observeVideo() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setTimeout(() => {
                    if (!entry.isIntersecting) {
                        this.videoWrapper.classList.remove('is-in-view');
                        this.pauseVideo.bind(this)();
                    } else {
                        this.videoWrapper.classList.add('is-in-view');
                        this.unpauseVideo.bind(this)();
                    }
                }, 500);
            });
        }, {});
    
        observer.observe(this.videoWrapper);
    }

    onMainMenuOpen(ev) {
        this.pauseVideo.bind(this)();
    }

    onMainMenuClose(ev) {
        if (this.videoWrapper.classList.contains('is-in-view')) {
            this.unpauseVideo.bind(this)();
        }
    }

    onPreloadComplete(ev) {
        // this.unpauseVideo.bind(this)();
        this.observeVideo.bind(this)();
    }

    events() {
        if (this.pauseBtn) {
            this.pauseBtn.addEventListener('click', this.onPauseBtnClick.bind(this), false);
        }

        if (this.muteBtn) {
            this.muteBtn.addEventListener('click', this.onMuteBtnClick.bind(this), false);
        }

        window.addEventListener('load', this.onWindowLoad.bind(this), false);
        window.addEventListener('mainMenu.open', this.onMainMenuOpen.bind(this), false);
        window.addEventListener('mainMenu.close', this.onMainMenuClose.bind(this), false);
        window.addEventListener('preloader.completed', this.onPreloadComplete.bind(this), false);
    }
}